var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GetStartedLayout",
    {
      ref: "layout",
      attrs: {
        errors: _vm.errors,
        title: "Great!",
        subtitle: "We'll hold this time while you checkout",
        breadcrumbs: _vm.breadcrumbs,
        guest: _vm.guest,
        child: _vm.child,
        review: _vm.review,
        location: _vm.guest.location,
      },
    },
    [
      _c(
        "v-col",
        {
          staticClass: "white--text text-center px-0",
          attrs: { cols: "12", sm: "10", md: "8", lg: "6" },
        },
        [
          _c(
            "v-card",
            {
              staticClass: "mx-auto",
              class: { "soli-round": _vm.$vuetify.breakpoint.smAndUp },
              attrs: { tile: _vm.$vuetify.breakpoint.xs },
            },
            [
              _c(
                "v-container",
                {
                  staticClass: "py-5",
                  class: _vm.$vuetify.breakpoint.smAndUp ? "px-5" : "px-0",
                },
                [
                  _c("Lesson", {
                    attrs: {
                      lesson: _vm.lesson,
                      errors: _vm.errors,
                      guest: _vm.guest,
                      child: _vm.child,
                    },
                  }),
                  _vm._v(" "),
                  false
                    ? _c("Experience", {
                        attrs: {
                          lesson: _vm.lesson,
                          guest: _vm.guest,
                          errors: _vm.errors,
                        },
                        model: {
                          value: _vm.form.experience,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "experience", $$v)
                          },
                          expression: "form.experience",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("GetStartedPayment", {
                    key: _vm.paymentReset,
                    ref: "payment",
                    attrs: {
                      guest: _vm.guest,
                      child: _vm.child,
                      location_id: _vm.lesson.room?.location_id,
                      teacherName: _vm.lesson.teacher?.name,
                      lesson: _vm.lesson,
                      errors: _vm.errors,
                    },
                    on: {
                      applyPromo: function ($event) {
                        _vm.$refs.layout.showMessage = true
                      },
                      submit: function ($event) {
                        return _vm.submit($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }